<script>
import AdminBatchChooser from '@/layerAdmin/components/AdminBatchChooser.vue';
import AdminReportsPerBatch from '@/layerAdmin/components/AdminReportsPerBatch.vue';

export default {
  components: {
    AdminBatchChooser,
    AdminReportsPerBatch,
  },

  data: () => ({
    batch: undefined,
  }),

  computed: {
    batchName: {
      get() { return this.$route.query.selected_batch || '' },
      set(value) { this.$router.push({ query: { selected_batch: value } }); },
    },
  },
}
</script>

<template>
  <div>
    <div class="row mb-3">
      <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
        <b-card class="mb-2">

          <div class="h5 m-0"> Admin Reports per Batch </div>

          <admin-batch-chooser v-model="batchName" :auto-focus="true" class="mt-3" required></admin-batch-chooser>

        </b-card>
      </div>
    </div>

    <api-loader
      v-if="batchName"
      :key="batchName"
      method="get"
      :url="`v1/layeradmin/batches/${encodeURIComponent(batchName)}`"
      @loaded="batch=$event" />

    <admin-reports-per-batch v-if="batch" :batch="batch" />

  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/AdminReportsPerBatchContainer.vue